module.exports = __webpack_public_path__ + "static/media/values_pic_mobile.b4a2c487.jpg";